// src/DataDeletion.jsx
export default function DataDeletion() {
  return (
    <div style={{maxWidth: 800, margin: "40px auto", padding: 24}}>
      <h1>Data Deletion Instructions</h1>
      <p>
        You have the right to request the deletion of your personal data from our app at any time.
      </p>
      <h2>How to request data deletion</h2>
      <ul>
        <li>
          Please send an email to <a href="mailto:nnofficial2414@gmail.com">nnofficial2414@gmail.com</a> with the subject line <strong>“Data Deletion Request”</strong>.
        </li>
        <li>
          In your email, please include the email address you used to sign up for the app so we can identify your account.
        </li>
      </ul>
      <h2>What happens next?</h2>
      <ul>
        <li>
          Once we receive your request, we will delete your account and all associated personal data from our systems.
        </li>
        <li>
          You will receive a confirmation email once your data has been deleted.
        </li>
        <li>
          We will process all data deletion requests within 30 days.
        </li>
      </ul>
      <h2>Questions?</h2>
      <p>
        If you have any questions about your data or this process, please contact us at <a href="mailto:nnofficial2414@gmail.com">nnofficial2414@gmail.com</a>.
      </p>
    </div>
  );
}
